/**
 * monetization/money — PURE format for amounts in cents (author payouts,
 * phase 2). The server always accounts in whole cents (largest remainder:
 * no floats in accounting); the client only formats for display.
 */

/**
 * Formats cents as an amount with a currency ("12.34 USD" → localized if
 * the currency is valid ISO-4217; plain fallback "12.34 XYZ" otherwise).
 */
export function formatCents(cents: number, currency: string, locale?: string): string {
  const amount = cents / 100;
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      currencyDisplay: "code",
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency}`;
  }
}
